import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreateInventoryTransactionType } from "../../../hooks/inventory/useCreateInventoryTransactionType";

const DefaultTypesSeederDialog = ({ open = false, setOpen, successCallback }) => {

    const { t } = useTranslation('common');

    const defaultTypes = [
        {name: "*correction", description: "Special type of transaction for correcting entry errors", custom: 0},
        {name: "administered", description: "Item administered to patient", custom: 0},
        {name: "purchased", description: "Purchase from a supplier or other sources", custom: 0},
        {name: "returned", description: "Returned to supplier (expired, damaged, recalled)", custom: 0},
        {name: "donated", description: "Given or received as donation", custom: 0},
        {name: "expired", description: "Expired stock removed from inventory", custom: 0},
        {name: "lost", description: "Lost or missing (e.g., misplaced, theft)", custom: 0},
        {name: "disposed", description: "Disposal of damaged or contaminated items", custom: 0},
        {name: "reserved", description: "Temporarily held for upcoming appointment or surgery", custom: 0},
        {name: "released", description: "Reserved stock released back to inventory", custom: 0}
    ];
    
    const handleClose = (event, reason) => {
        // Prevent closing when clicking the backdrop or pressing Escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
        }
        setOpen(false);
    };

    const { create } = useCreateInventoryTransactionType(successCallback);

    const onConfirm = () => {
        createDefaultTypes();
        setOpen(false);
    }

    const createDefaultTypes = async () => {
        await create(defaultTypes);
    };

    return (
        <Dialog open={open} onClose={handleClose} disableRestoreFocus>
                <DialogTitle>
                    Transaction Types Initial Setup...
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        The system has created a default set of Inventory Transaction Types. 
                        <br /><br />
                        Customize this list by going to the Inventory Transaction Types management.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={onConfirm}
                    color="primary"
                    >
                    Got it
                    </Button>
                </DialogActions>
        </Dialog>
  );
};

export default DefaultTypesSeederDialog;